var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrowse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m7.951 11.695.023.074q.012.055.02.114L8 12c0 .552-.453 1-.997 1H.997A.996.996 0 0 1 0 12c0-.552.453-1 .997-1l5.397.001a7 7 0 0 0 1.557.694M10 0a5 5 0 0 1 3.277 8.776L16 11.5 14.5 13l-3.177-3.177A5.006 5.006 0 0 1 5 5a5 5 0 0 1 5-5M5.103 10.002 1.003 10a.999.999 0 1 1 0-2h2.671c.356.75.842 1.427 1.429 2.002M10 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 5c0 .695.101 1.367.29 2.001L1.002 7a.999.999 0 1 1 0-2zm.07-1H.996A.995.995 0 0 1 0 3c0-.552.456-1 .995-1h2.679a7 7 0 0 0-.603 2"
})));
export default SvgBrowse;